import { z } from 'zod';
import { surrendersSortByValues } from 'src/apis/monolith/mappings';
import {
  ascSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { periodTypeValues } from 'src/pages/reporting/auctions/components/period-type';
import { useAuctionLivePageParams } from 'src/pages/transport/network-points/details/point-details/auction-live-table';

const recentAuctionsSchema = z.object({
  periodType: z.enum(periodTypeValues).default('WITHINDAY'),
});

const longTermAuctionsSchema = getPaginationSchema();

const shortTermAuctionsSchema = getPaginationSchema();

const tasLongTermAuctionsSchema = getPaginationSchema();

const tasShortTermAuctionsSchema = getPaginationSchema();

const offeredProposalsSchema = getPaginationSchema();

const requestedProposalsSchema = getPaginationSchema();

const surrenderedCapacitySchema = z.object({
  sortColumn: z.enum(surrendersSortByValues).default('runtimeStart'),
  sortAscending: ascSortDirectionSchema,
  ...getPaginationSchema().shape,
});

export function useNwpDetailParams() {
  const auctionLive = useAuctionLivePageParams();

  const recentAuctions = usePageParamsFromSchema(recentAuctionsSchema, {
    groupPrefix: 'recentAuctions',
  });

  const longTermAuctions = usePageParamsFromSchema(longTermAuctionsSchema, {
    groupPrefix: 'longTermAuctions',
  });

  const shortTermAuctions = usePageParamsFromSchema(shortTermAuctionsSchema, {
    groupPrefix: 'shortTermAuctions',
  });

  const tasLongTermAuctions = usePageParamsFromSchema(
    tasLongTermAuctionsSchema,
    {
      groupPrefix: 'tasLongTermAuctions',
    }
  );

  const tasShortTermAuctions = usePageParamsFromSchema(
    tasShortTermAuctionsSchema,
    {
      groupPrefix: 'tasShortTermAuctions',
    }
  );

  const offeredProposals = usePageParamsFromSchema(offeredProposalsSchema, {
    groupPrefix: 'offeredProposals',
  });

  const requestedProposals = usePageParamsFromSchema(requestedProposalsSchema, {
    groupPrefix: 'requestedProposals',
  });

  const surrenderedCapacity = usePageParamsFromSchema(
    surrenderedCapacitySchema,
    {
      groupPrefix: 'surrenderedCapacity',
    }
  );

  return {
    auctionLive,
    recentAuctions,
    longTermAuctions,
    shortTermAuctions,
    tasLongTermAuctions,
    tasShortTermAuctions,
    offeredProposals,
    requestedProposals,
    surrenderedCapacity,
  };
}

export type NwpDetailParams = ReturnType<typeof useNwpDetailParams>;
